export const fieldLabelMap: Record<string, string> = {
  currentProcess: 'Current Process',
  expectedImpact: 'Expected Impact',
  specificIdeasOfImprovement: 'Specific Ideas Of Improvement',
  keyPerformanceIndicators: 'Key Performance Indicators',
};

export const fieldAPIKeyMap: Record<string, string> = {
  currentProcess: 'current_process',
  expectedImpact: 'expected_impact',
  specificIdeasOfImprovement: 'ideas_of_improvement',
  keyPerformanceIndicators: 'key_performance_indicator',
  current_process: 'current_process',
  expected_impact: 'expected_impact',
  ideas_of_improvement: 'ideas_of_improvement',
  key_performance_indicator: 'key_performance_indicator',
};

export const chatBotFieldMap: Record<string, string> = {
  currentProcess: 'current_process_chat',
  expectedImpact: 'expected_impact_chat',
  specificIdeasOfImprovement: 'specific_ideas_of_improvement_chat',
  keyPerformanceIndicators: 'key_performance_indicators_chat',
};

export const getFieldKeyFromCategory: Record<string, string> = {
  'Current Process': 'current_process',
  'Expected Impact': 'expected_impact',
  KPIs: 'key_performance_indicator',
  'Specific Idea of Improvement': 'ideas_of_improvement',
};
